const restuarant = `Subject: Complaint About My Bad Restaurant Visit
Dear Manager,
I want to tell you about my bad experience at your restaurant. 
When I ate there yesterday, I found a hair in my food, which was really gross.
Also, the waiter was not nice when I told them about it. They were rude and didn't seem to care.
Please make sure your restaurant is clean, and your staff is polite to customers. 
It's important to make sure this doesn't happen to anyone else.
I would like to get an official apology and the money back.
I am also thinking about making an official complaint about this,
Please make necessary actions so that this doesnt happen again`;
export default restuarant;